// EmployeeBreakActions.ts

import { Dispatch } from "redux";
import { EmployeeBreak } from "../../types/EmployeeBreak";
import {
  insertEmployeeStartBreak,
  updateEmployeeEndBreak,
  getSingleEmployeeBreak,
  getTotalBreakByDateIfCheckedOut,
  getTotalBreakEmployeeByDate,
} from "../../services/EmployeeBreakService";

// Action Types
export enum EmployeeBreakActionList {
  START_BREAK = "START_BREAK",
  END_BREAK = "END_BREAK",
  FETCH_SINGLE_BREAK = "FETCH_SINGLE_BREAK",
  FETCH_TOTAL_BREAK = "FETCH_TOTAL_BREAK",
  FETCH_TOTAL_CHECKEDOUT_BREAK = "FETCH_TOTAL_CHECKEDOUT_BREAK",
}

// Action Interfaces
export interface StartBreakAction {
  type: EmployeeBreakActionList.START_BREAK;
  data: EmployeeBreak;
}

export interface EndBreakAction {
  type: EmployeeBreakActionList.END_BREAK;
  data: EmployeeBreak;
}

export interface FetchSingleBreakAction {
  type: EmployeeBreakActionList.FETCH_SINGLE_BREAK;
  data: EmployeeBreak;
}

export interface FetchTotalBreakAction {
  type: EmployeeBreakActionList.FETCH_TOTAL_BREAK;
  data: EmployeeBreak;
}

export interface FetchTotalCheckedOutBreakAction {
  type: EmployeeBreakActionList.FETCH_TOTAL_CHECKEDOUT_BREAK;
  data: EmployeeBreak;
}

export type EmployeeBreakActions =
  | StartBreakAction
  | EndBreakAction
  | FetchSingleBreakAction
  | FetchTotalBreakAction
  | FetchTotalCheckedOutBreakAction;

// Action Creators

export const startBreakAction = (data: EmployeeBreak) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await insertEmployeeStartBreak(data);

      dispatch<StartBreakAction>({
        type: EmployeeBreakActionList.START_BREAK,
        data: response.data,
      });
      return Promise.resolve(response.data ?? "Break started");
    } catch (error: any) {
      return Promise.reject(error.message ?? "Unable to start break");
    }
  };
};

export const endBreakAction = (data: EmployeeBreak) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await updateEmployeeEndBreak(data);
      dispatch<EndBreakAction>({
        type: EmployeeBreakActionList.END_BREAK,
        data: response.data,
      });
      return Promise.resolve(response.data ?? "Break ended");
    } catch (error: any) {
      return Promise.reject(error.message ?? "Unable to end break");
    }
  };
};

export const fetchSingleBreakAction = (id: string) => {
  return async (dispatch: Dispatch) => {
    const response = await getSingleEmployeeBreak(id);
    dispatch<FetchSingleBreakAction>({
      type: EmployeeBreakActionList.FETCH_SINGLE_BREAK,
      data: response,
    });
  };
};

export const fetchTotalBreakByDateAction = (
  employeeId: string,
  date: string,
) => {
  return async (dispatch: Dispatch) => {
    const response = await getTotalBreakEmployeeByDate(employeeId, date);
    dispatch<FetchTotalBreakAction>({
      type: EmployeeBreakActionList.FETCH_TOTAL_BREAK,
      data: response,
    });
    return response;
  };
};

export const fetchTotalBreakCheckedOutAction = (
  employeeId: string,
  date: string,
) => {
  return async (dispatch: Dispatch) => {
    const response = await getTotalBreakByDateIfCheckedOut(employeeId, date);
    dispatch<FetchTotalCheckedOutBreakAction>({
      type: EmployeeBreakActionList.FETCH_TOTAL_CHECKEDOUT_BREAK,
      data: response,
    });
    return response;
  };
};
